const AppointmentProgressTracker = ({ steps = [] }) => {
  return (
    <div className="stepper-wrapper">
      {steps.map((step) => {
        let stepClass = '';

        if (step.status === 'completed') {
          stepClass = 'completed';
        } else if (step.status === 'pending') {
          stepClass = 'active';
        }

        return (
          <div className={`stepper-item ${stepClass}`} key={step.stepID}>
            <div className="step-counter"></div>
            <div className="step-name">{step.name}</div>
          </div>
        );
      })}
    </div>
  );
};

export default AppointmentProgressTracker;